export enum ResearchDashboardBlock {
  Root = 'ResearchDashboard',
}

export enum ResearchDashboardElement {
  TrackRecord = 'trackRecord',
}
